import type { ConfigurationActiveCampaignVouchersQuery } from '@/graphql/configuration/api';

type ActiveCampaignVoucher =
  ConfigurationActiveCampaignVouchersQuery['activeCampaignVouchers'][number];

export const fetchActiveCampaignVouchers = async (channel: string) => {
  const response = await fetch(
    `/api/configuration/active-campaign-vouchers?channel=${encodeURIComponent(
      channel,
    )}`,
  );

  if (!response.ok) {
    throw new Error('Failed to fetch active campaign vouchers');
  }

  return (await response.json()) as ActiveCampaignVoucher[];
};
